import React, { useState, useEffect, useCallback } from "react";
import { CancelRequest } from "../../../services/AxiosInstance";
import { useNavigate, Link } from "react-router-dom";
import Pagination from "../../constant/Pagination";
import TableLoaderEffect from "../../constant/TableLoader";
import DebounceSearchInput from "../../constant/DebounceSearchInput";
import { getcalibrationListApi } from "../../../services/CalibrationService";
import AddCalibration from "./AddCalibration";

const Calibration = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [query, setSearchQuery] = useState("");
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const recordsPage = 25;

  const navigate = useNavigate();

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    getcalibrationListApi(currentPage, recordsPage, query)
      .then((resp) => {
        setData(resp.data.data);
        setTotal(resp.data.total);
      })
      .catch((error) => {
        console.error(error.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage, query]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handleSearchChange = (value) => {
    CancelRequest();
    setSearchQuery(value);
    setCurrentPage(1);
  };

  const handleAfterCreate = (newData) => {
    setData((prevData) => [newData, ...prevData]);
    setTotal((prevTotal) => prevTotal + 1);
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-header">
                <h3 className="mb-0">Calibration List</h3>
                <div className="table-left-header">
                  <div className="form-group me-3">
                    <DebounceSearchInput
                      handleSearchChange={handleSearchChange}
                    />
                  </div>
                  <AddCalibration handleAfterCreate={handleAfterCreate} />
                </div>
              </div>

              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                <table
                  id="empoloyees-tblwrapper"
                  className="table ItemsCheckboxSec dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th className="fw-bold">Name</th>
                      <th className="fw-bold">Description</th>
                      <th className="fw-bold">Schedule At</th>
                      <th className="fw-bold">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <TableLoaderEffect colLength={5} />
                    ) : (
                      data?.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <Link
                              to={`/calibration/${item.id}`}
                              className="fw-bold text-primary"
                            >
                              {item.name}
                            </Link>
                          </td>
                          <td
                            className="text-wrap"
                            style={{ maxWidth: "300px" }}
                          >
                            {item.description}
                          </td>
                          <td>{item?.scheduled_at}</td>
                          <td>
                            {item?.status === "pending" ? (
                              <span className="badge light border-0 badge-warning badge-sm">
                                Pending
                              </span>
                            ) : item?.status === "completed" ? (
                              <span className="badge light border-0 badge-success badge-sm">
                                Completed
                              </span>
                            ) : item?.status === "in_progress" ? (
                              <span className="badge light border-0 badge-info badge-sm">
                                In-progress
                              </span>
                            ) : (
                              <span className="badge light border-0 badge-danger badge-sm">
                                Cancelled
                              </span>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {isLoading ? (
                <div style={{ height: "4rem" }}></div>
              ) : (
                <Pagination
                  currentPage={currentPage}
                  recordsPage={recordsPage}
                  dataLength={total}
                  handlePagination={handlePagination}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Calibration;
